import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { OnboardingCtaBanner } from './onboarding-cta-banner';
import { OnboardingWidget } from './onboarding-widget';
import { useToggle } from '../../infra/small-tools/use-toggle';
import { useFeatureFlags } from '../../infra/feature-flags';
export var Onboarding = function () {
    var showShopOnboarding = useFeatureFlags().shopOnboarding;
    var widget = useToggle(true);
    if (!showShopOnboarding) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(OnboardingCtaBanner, { onClick: widget.setOn }), _jsx(OnboardingWidget, { isOpen: widget.isOn, handleCloseWidget: widget.setOff })] }));
};
